module.exports = __webpack_public_path__ + "static/media/image04.8a8fc4f4.jpg";